import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance, {
  CustomAxiosRequestConfig,
} from "../../../Api/axiosInstance";

export const getEmployeeList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_LIST,
    { params: params }
  );
  console.log(
    "🚀 ~ file: EmployeeRepository.ts ~ line 9 ~ getEmployeeList ~ response",
    response
  );
  return response.data;
};

export const getOrgUnits = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EMPLOYEE.GET_ORG_UNITS
  );
  let dt = response?.data?.data;
  if (dt && Object.keys(dt)?.length > 0) {
    let data = Object.keys(dt).reduce((arr: any, id: any) => {
      arr.push({ id: id, label: dt[id] });
      return arr;
    }, []);
    data?.unshift({ id: "null", label: "All" });
    console.log(
      "🚀 ~ file: EmployeeRepository.ts ~ line 21 ~ getOrgUnits ~ response",
      data
    );
    return { data, response: dt };
  }
  return { data: [], response: {} };
};

export const getGradeMasters = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EMPLOYEE.GET_GRADE_MASTERS
  );
  let dt = response?.data?.data;

  console.log("🚀 ~ EmployeeRepository.ts:32 ~ getGradeMasters ~ dt:", dt);

  if (dt && dt.length > 0) {
    // let data = Object.keys(dt).reduce((arr: any, id: any) => {
    //   arr.push({ id: id, label: dt[id] });
    //   return arr;
    // }, []);
    let data = dt.map((item: any, index: any) => ({
      id: item?.Gradeid,
      label: item?.GradeName,
    }));
    data?.unshift({ id: "null", label: "All" });
    console.log(
      "🚀 ~ file: EmployeeRepository.ts ~ line 36 ~ getGradeMasters ~ response",
      data
    );
    return { data, response: dt };
  }
  return { data: [], response: {} };
};
export const getDesignations = async () => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EMPLOYEE.GET_DESIGNATIONS
  );
  let dt = response?.data?.data;
  if (dt && Object.keys(dt)?.length > 0) {
    let data = Object.keys(dt).reduce((arr: any, id: any) => {
      arr.push({ id: id, label: dt[id] });
      return arr;
    }, []);
    data?.unshift({ id: "null", label: "All" });
    // console.log(
    //   "🚀 ~ file: EmployeeRepository.ts ~ line 51 ~ getDesignations ~ response",
    //   data
    // );
    return { data, response: dt };
  }
  return { data: [], response: {} };
};

export const getEmployeeStatus = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_STATUS
  );
  let dt = response?.data?.data?.EmpStatus;
  if (dt && Object.keys(dt)?.length > 0) {
    let data = Object.keys(dt).reduce((arr: any, id: any) => {
      arr.push({ id: id, label: dt[id] });
      return arr;
    }, []);
    data?.unshift({ id: "null", label: "All" });
    // console.log(
    //   "🚀 ~ file: EmployeeRepository.ts ~ line 66 ~ getEmployeeStatus ~ response",
    //   data
    // );
    return { data, response: dt };
  }
  return { data: [], response: {} };
};

export const getEmployeeDetailsByID = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_DETAILS_BY_ID,
    { params }
  );
  return response.data;
};


export const getPositionData= async(params?:Record<string,any>)=>{
  const response=await axiosInstance.get(
    API_ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_POSITION,{params:params}
  );
  return response.data;
}

export const getReportingToPositionData= async(params?:Record<string,any>)=>{
  const response=await axiosInstance.get(
    API_ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_REPORTING_TO,{params:params}
  );
  return response.data;
}

export const EditProfile = async (Reqbody: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.EMPLOYEE.EDIT_EMPLOYEE_PROFILE}`, Reqbody);
    return response.data;
}

export const UpdateUserProfile = async (Reqbody: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.EMPLOYEE.UPDATE_USER_PROFILE}`, Reqbody);
    return response.data;
}

export const DayLockedList = async (Reqbody: Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_DAY_LOCKED_LIST}`, {params:Reqbody});
    return response.data;
}

export const DayLockedDatesByID = async (params: Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_DAY_LOCKED_DATE_BY_ID}`, {params:params});
    return response.data;
}


export const ReleaseDayLockedDates = async (body: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.EMPLOYEE.RELEASE_DAY_LOCKED}`, body);
    return response.data;
  }
export const ReleaseAllDayLock = async (body: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.EMPLOYEE.RELEASE_ALL_DAY_LOCK}`, body);
    return response.data;
}

export const AccountLockedList = async (params: Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_ACCOUNT_LOCKED_LIST}`, {params:params});
    return response.data;
}




export const ReleaseAccountLocked = async (body: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.EMPLOYEE.RELEASE_ACCOUNT_LOCKED}`, body);
    return response.data;
}


export const DocumnetAccountLockedList = async (params: Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_DOCUMENT_ACCOUNT_LOCKED}`, {params:params});
    return response.data;
}

export const getEODstatus = async () => {
    let response = await axiosInstance.get(API_ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_STATUS);
    return response.data;
}

export const getUserSession = async (empId?: number,params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_USER_SESSION}/${empId}`,{params});
    return response.data;
}

export const getUserProfile = async (params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_USER_PROFILE}`,{params});
    return response.data;
}

export const getRoles=async (params?:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.CONFIGURATION.GET_ROLES_LIST}`,{params});
    return response.data;
}


export const CanLoginApp = async (body: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.EMPLOYEE.UPDATE_ACCESS_CAN_LOGIN}`, body);
    return response.data;
}

export const ChangeEmployeeStatus = async (body: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.EMPLOYEE.UPDATE_EMPLOYEE_STATUS}`, body);
    return response.data;
}

export const UpdateHrUserDates = async (body: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.EMPLOYEE.UPDATE_HR_USER_DATES}`, body);
    return response.data;
}

export const GetAttendanceList = async (params: Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_ATTENDANCE_LIST}`, {params});
    return response.data;
}

export const GetSGPIListByEMP = async (empID:Number,params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_SGPI_BY_EMPLOYEE_ID}/${empID}`,{params});
    return response.data;
}

export const GetEmployeeLeaveBAlance = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_LEAVE_BALANCE}`,{params});
    return response.data;
}

export const getLeaveListByEmployee = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_LEAVE_LIST_BY_EMPLOYEE}`,{params});
    return response.data;
}


export const getDailyCallByAttendance = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_DAILY_CALLS_BY_ATTENDANCE}`,{params});
    return response.data;
}

export const getAllPositionList = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_ALL_POSITION_LIST}`,{params});
    return response.data;
}

export const getExpenseSingleDateById = async (params:Record<string,any>,id:number) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_EXPENSE_SINGLE_DATE_BY_EMPLOYEE_ID}/${id}`,{params});
    return response.data;
}

export const getEmployeeGeoTown = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_GEO_TOWN}`,{params});
    return response.data;
}

export const getSingleAttendance = async (id:number) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_SINGLE_ATTENDANCE}/${id}`);
    return response.data;
}

export const getBranches = async () => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_BRANCHES}`);
    return response.data;
}

export const updateAttendance = async (body: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.EMPLOYEE.UPDATE_ATTENDANCE}`, body);
    return response.data;
}

export const regenerateExpense = async (body: Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.EMPLOYEE.REGENERATE_EXPENSE}`, body);
    return response.data;
}

export const addEmployeeProfile = async (body: Record<string,any>) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.EMPLOYEE.ADD_EMPLOYEE_PROFILE}`, body);
    return response.data;
}
export const getPositionListNew = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_POSITION_LIST_NEW}`,{params});
    return response.data;
}

export const getReportingToPositionsByOrgUnit = async (params:Record<string,any>,id:number) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_REPORTING_TO_BY_ORG_UNIT}/${id}`,{params});
    return response.data;
}

export const getTownFilter=async(params:Record<string,any>)=>{
  let reponse= await axiosInstance.get(`${API_ENDPOINTS.Beat.GET_TOWN_FILTER}`,{params})
  return reponse.data
}
export const getPositionById=async(id:number)=>{
  let reponse= await axiosInstance.get(`${API_ENDPOINTS.EMPLOYEE.GET_POSITION_BY_ID}/${id}`)
  return reponse.data
}

export const addPositions=async(body:Record<string,any>)=>{
  let reponse= await axiosInstance.post(`${API_ENDPOINTS.EMPLOYEE.ADD_POSITIONS}`,body)
  return reponse.data
}

export const updatePositions=async(body:Record<string,any>,id:number)=>{
  let reponse= await axiosInstance.put(`${API_ENDPOINTS.EMPLOYEE.UPDATE_POSITIONS}/${id}`,body)
  return reponse.data
}